import React, { useState } from 'react';
import { products } from '../data/products';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="gallery-page">
      <div className="gallery-hero">
        <div className="gallery-hero-content">
          <h1>Product Gallery</h1>
          <p>Explore our premium cocopeat and coir products through our visual gallery</p>
        </div>
      </div>

      <div className="gallery-container">
        <div className="container">
          <div className="gallery-grid">
            {products.map((product, index) => (
              <div 
                key={product.id} 
                className="gallery-item"
                onClick={() => setSelectedImage({ ...product, index })}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="gallery-image-wrapper">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x300?text=' + encodeURIComponent(product.name);
                    }}
                  />
                  <div className="gallery-overlay">
                    <div className="gallery-info">
                      <h3>{product.name}</h3>
                      <span>{product.category}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button className="lightbox-close" onClick={() => setSelectedImage(null)}>
            ×
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.image} 
              alt={selectedImage.name}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/800x600?text=' + encodeURIComponent(selectedImage.name);
              }}
            />
            <div className="lightbox-info">
              <h2>{selectedImage.name}</h2>
              <p className="lightbox-category">{selectedImage.category}</p>
              <p className="lightbox-description">{selectedImage.description}</p>
            </div>
          </div>
          {selectedImage.index > 0 && (
            <button 
              className="lightbox-nav lightbox-prev"
              onClick={(e) => {
                e.stopPropagation();
                const prevProduct = products[selectedImage.index - 1];
                setSelectedImage({ ...prevProduct, index: selectedImage.index - 1 });
              }}
            >
              ‹
            </button>
          )}
          {selectedImage.index < products.length - 1 && (
            <button 
              className="lightbox-nav lightbox-next"
              onClick={(e) => {
                e.stopPropagation();
                const nextProduct = products[selectedImage.index + 1];
                setSelectedImage({ ...nextProduct, index: selectedImage.index + 1 });
              }}
            >
              ›
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Gallery;

